module.exports = __webpack_public_path__ + "img/9.1.9e261c91.jpg";